import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { OrganizationContext } from '@BUP/contexts/OrganizationContext'
import { LocationContext } from '@BUP/contexts/LocationContext'
import { findNivel } from '@BUP/services/BraveUp'
import { multiCourse } from '@BUP/constants'

const CourseName = ({ message }) => {
  const i18n = useTranslation()
  const organization = useContext(OrganizationContext)
  const locale = useContext(LocationContext)
  const course = message?.Enrollment?.registrations?.[0]?.course || {}

  if (!course?.name) return <span>- {i18n.t('common.resources.course.actions.read.name.failure', { context: 'missing' })}</span>

  const { locale: lang } = locale
  const { type: organizationType } = organization
  const isMultiCourse = organizationType === multiCourse
  const nivel = findNivel(lang, course)
  const nivelName = nivel ? nivel.name : i18n.t('common.resources.course.level.missing')

  const courseName = isMultiCourse ? nivelName : course.name
  return <span>{courseName}</span>
}

export default CourseName
